import { getCountryCode } from '@bridebook/web/lib/i18n/selectors';
import { mapEventToAppsFlyerEvent } from '@bridebook/web/lib/track-utils/mappers/event-to-appsflyer-event';
import { ITrackingMapper } from '@bridebook/web/lib/track-utils/tracking-mappers';

export const commonMapper: ITrackingMapper = ({ event }, state) => [
  mapEventToAppsFlyerEvent(event),
  {
    country_code: getCountryCode(state),
  },
];
